import { connect } from 'react-redux';
import { ReactNode, RefObject } from 'react';

import { IDecision } from 'APIPackage/DecisionModule/interfaces/IDecision';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';

import { IDecisionForm } from '../interfaces/IDecisionForm';
import { DecisionContent } from './DecisionContent';
import { DecisionMenu } from './DecisionMenu';
import { IDictionaryEventTypeSelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionaryEventTypeSelectOption';
import { DecisionMenuItemsIdsEnum } from '../enums/DecisionMenuItemsIdsEnum';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { getDecisionEventTypesSelectOptions } from '../selectors/decisionSelectors';

interface IDecisionPassportFormRenderProps {
  decisionData?: IDecision;
  bodyRef: RefObject<HTMLDivElement>;
  values: IDecisionForm;
  renderForm: (menu: ReactNode, content: ReactNode) => ReactNode;
  settings: IAdminSetting[] | undefined;
}

interface IDecisionPassportFormRenderStoreProps {
  eventTypesSelectOptions: IDictionaryEventTypeSelectOption[] | undefined;
}

export const DecisionPassportFormRenderWithoutStore = ({
  decisionData,
  bodyRef,
  values,
  renderForm,
  eventTypesSelectOptions,
  settings,
}: IDecisionPassportFormRenderProps & IDecisionPassportFormRenderStoreProps) => {
  const isUse4151 = isLaterThanAdminSetting(
    values.created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_223_4_1_16_STARTS_FROM,
  );

  const hiddenItemsIds = [];

  if (!isUse4151) {
    hiddenItemsIds.push(DecisionMenuItemsIdsEnum.DECISION_ACT);
  }

  if (!eventTypesSelectOptions?.length) {
    hiddenItemsIds.push(DecisionMenuItemsIdsEnum.DECISION_EVENTS);
  }

  const menu = <DecisionMenu dataRef={bodyRef} hiddenItemsIds={hiddenItemsIds} />;

  const content = <DecisionContent decisionData={decisionData} values={values} />;

  return <>{renderForm(menu, content)}</>;
};

const mapStateToProps = (state: IRootState): IDecisionPassportFormRenderStoreProps => ({
  eventTypesSelectOptions: getDecisionEventTypesSelectOptions(state),
});

export const DecisionPassportFormRender = connect(mapStateToProps)(DecisionPassportFormRenderWithoutStore);
